// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"d348d29d","953":"7419f0c6"}[chunkId] + ".chunk.css";
};